import type { ComponentType } from 'react';
import type { Element } from '@/components/canvas/document/publicTypes';
import type { ElementComponentProps } from '@/components/canvas/elements/types';
import { getElementComponents } from '@/components/canvas/elements/registry/elementRegistry';
import { ensureBuiltinElementsRegistered } from './registerBuiltinElements';

type NonGroupElementType = Exclude<Element['type'], 'group'>;

let cached: Record<NonGroupElementType, ComponentType<ElementComponentProps>> | null = null;

/**
 * 已注册内置元素的渲染组件表（不含 group）。
 * 首次调用前须已通过 ensureBuiltinElementsRegistered 完成注册。
 */
export function getBuiltinElementComponents(): Record<
  NonGroupElementType,
  ComponentType<ElementComponentProps>
> {
  ensureBuiltinElementsRegistered();
  if (!cached) {
    cached = getElementComponents() as Record<NonGroupElementType, ComponentType<ElementComponentProps>>;
  }
  return cached;
}
